import { mSecondsFromEpoch } from 'src/app/types/@types/sl-v-types';
import { DateKind } from './../components/criteria/date-kind/date-kind.component';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { DateIsAPair, dateIsAWhatMap } from './../components/criteria/date-is-a/date-is-a.component';
import { DateQualifierService } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { DateBuffer } from './../components/criteria/date-buffer/date-buffer.component';
import { Injectable } from '@angular/core';
import { range } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CriteriaService {

  constructor() { }

  public static DateBufferCriteriaToString(buffer: DateBuffer): string {
    const info = buffer.bufferInfo;
    let range = info.range;
    switch (range) {
      case '+-':
        range = '+/- ';
        break;
    }
    let out = `within ${range}${info.count} ${info.which} of `;
    const dateStr = DateQualifierService.ToString(new Date(buffer.targetDate), 'date#March 04, 2345')
    return out + dateStr;
  }
  public static DaysCriteriaToString(days: string): string {
    return 'falls on a ' + days.replace(/,/g, ', ');
  }

  public static DateFirstDOWCriteriaToString(dow: number): string {
    return 'is the first day of the week (' + DateQualifierService.days[dow] + ')';
  }
  public static DateIsACriteriaToString(value: DateIsAPair): string {
    if (value.what === 'year') {
      return 'is the year ' + value.which;
    }
    const whichStr = NumberQualifierService.GetStNdRd(value.which);
    let out = `is the ${whichStr} ` + dateIsAWhatMap[value.what];
    return out;
  }
  public static DateKindCriteriaToString(dateKind: DateKind): string {
    let out = CriteriaService.DateIsACriteriaToString(dateKind.isA);
    if (dateKind.isA.what === 'dow') {
      out = out.replace('of the week', 'of weeks');
      out += ' starting on a ' + DateQualifierService.daysFull[dateKind.weekStart];
    }
    return out;
  }

  public static DateMonthsCriteriaToString(months: Array<number>) {
    const ranges = [];
    let firstMonth;
    let lastMonth;
    let finalMonth;
    for (const month of months) {
      if (month >= 12) continue;
      if (month < 0) continue;
      finalMonth = month;
      if (firstMonth === undefined) firstMonth = month;
      if (lastMonth === undefined) lastMonth = month;
      if (month - lastMonth > 1) {
        const range = (lastMonth-firstMonth > 0) ? [firstMonth, lastMonth] : [lastMonth];
        ranges.push(range);
        firstMonth = month;
        lastMonth = month;
        continue;
      }
      lastMonth = month;
    }
    if (firstMonth === lastMonth) {
      ranges.push([lastMonth])
    } else if (finalMonth === lastMonth) {
      if (finalMonth - firstMonth > 0) {
        ranges.push([firstMonth, lastMonth]);
      } else {
        ranges.push([lastMonth]);
      }
    }
    let out = 'is the month of ';
    let isFirst = true;
    for (const range of ranges) {
      out += (isFirst) ? '' : ', ';
      out += DateQualifierService.months[range[0]];
      if (range.length === 2) {
        out += '-' + DateQualifierService.months[range[1]];
      }
      isFirst = false;
    }
    if(ranges.length > 2) {
      const parts = out.split(',');
      parts[parts.length-1] = ' or ' + parts[parts.length-1].trim();
      out = parts.join(',');
    }
    if(ranges.length === 2) {
      const parts = out.split(', ');
      out = parts.join(' or ');
    }
    return out;
  }
  public static DateOfCriteriaToString(value:mSecondsFromEpoch) {
    return 'of '+DateQualifierService.DateToDB(new Date(value));
  }

  public static DateValToString(value:Date) {
    return 'is '+DateQualifierService.DateToDB(value);
  }
}
